export const newMascots = {
  1: 'https://daymade-website-assets.s3.amazonaws.com/2026/mascots/Mascot1.png',
  2: 'https://daymade-website-assets.s3.amazonaws.com/2026/mascots/Mascot2.png',
  3: 'https://daymade-website-assets.s3.amazonaws.com/2026/mascots/Mascot3.png',
  4: 'https://daymade-website-assets.s3.amazonaws.com/2026/mascots/Mascot4.png',
};

export const dashboardFolder =
  'https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/dashboard';
